import { FC } from "react";
import { t } from "../../common/miscellaneous/t";
import { FieldError } from "../../forms/components/FieldError";
import { AsyncLoader } from "../hooks/useAsyncLoader";

type RequestErrorsProps = { readonly loader: AsyncLoader<unknown> | undefined };

/**
 * @deprecated Duplicate of `src\common-loader\components\LoaderErrors.tsx`
 */
export const TopAppLoaderErrors: FC<RequestErrorsProps> = (props) => {
  return (
    <>
      {props.loader?.tag === "errors"
        ? props.loader.errors.map((error, index) => {
            return (
              <div className="tw-font-bold tw-text-sm" key={index}>
                <FieldError message={t(error)} />
              </div>
            );
          })
        : null}
    </>
  );
};
